module.exports = __webpack_public_path__ + "static/media/Summer-Matthews.4fb11b8b.jpg";